export default "__VITE_ASSET__a2c286c6__"